module.exports = __webpack_public_path__ + "static/media/hadensi.e9d71510.jpg";